/**
 * Versão funcional exibida pela interface, informada pelo service worker e
 * persistida nas configurações locais após as migrations.
 */
export const APP_VERSION = '1.0.0'
